// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`LargeCircleIcon test Match con el snapshot 1`] = `""`;
